import { ReportSummaryMapping } from '../../../../components/report/redesigned';
import { ReportSummaryInterface } from '../../../common/ReportSummaryInterface';

export interface SupplierAccountsReceivableSummary extends ReportSummaryInterface {
  invoices: number;
  totalOutstanding: number;
  current: number;
  thirtyOneTo60: number;
  sixtyOneTo90: number;
  over90: number;
}

export const supplierAccountsReceivableSummaryMapping = [
  { id: 'invoices', label: 'Invoices', formatter: 'number' },
  { id: 'totalOutstanding', label: 'Total Outstanding AR', formatter: 'currency' },
  { id: 'current', label: 'Current (0-30 days)', formatter: 'currency' },
  { id: 'thirtyOneTo60', label: '31-60 Days', formatter: 'currency' },
  { id: 'sixtyOneTo90', label: '61-90 Days', formatter: 'currency' },
  { id: 'over90', label: 'Over 90 Days', formatter: 'currency' },
] satisfies ReportSummaryMapping[];

